import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import type { MaterialType } from "@tfg/db"
import { AxiosError } from "axios"

import { materialTypeUpdateValidationType } from "@tfg/types/schemas/admin"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useUpdateMaterialTypeMutation = (
  options?: UseMutationOptions<
    MaterialType,
    unknown,
    { materialId: number; materialType: materialTypeUpdateValidationType }
  >
) =>
  useMutation<
    MaterialType,
    AxiosError,
    { materialId: number; materialType: materialTypeUpdateValidationType }
  >({
    ...options,
    mutationFn: async ({ materialId, materialType }) => {
      const res = await httpClient.patch<MaterialType>(
        `/admin/materialTypes/${materialId}`,
        materialType
      )
      return res.data
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      await queryClient.invalidateQueries({
        queryKey: ["materialTypes"],
      })
      showSuccessNotification({
        title: "Added",
        message: `Successfully updated material type : ${variables.materialType.key}`,
      })
    },
    onError: (error, variables, onMutateResult, context) => {
      options?.onError?.(error, variables, onMutateResult, context)
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage: `Failed to update material type : ${variables.materialType.key}, ERROR : ${
          error.response?.data ?? error.response?.data ?? error.message
        }`,
        showNotification: true,
        error: error as Error,
      })
    },
  })
